import { Modal, Radio, Form, Row, Col, Button } from 'antd'
import React, { useState } from 'react'
import { ButtonEx } from '../../../../styles/button.style'
import _, { isNull } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'

const UpdateStatus = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        status: formData.status,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          status: values.status
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <Modal
      width={600}
      title="Update Status"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item>
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group
              name="advance"
            >
              <Radio style={radioStyle} value='PENDING'><b>PENDING</b></Radio>
              <Radio style={radioStyle} value='REGISTERED'><b>REGISTERED</b></Radio>
              <Radio style={radioStyle} value='APPROVED'><b>APPROVED</b></Radio>
              <Radio style={radioStyle} value='SUSPENDED'><b>SUSPENDED</b></Radio>
              <Radio style={radioStyle} value='SUGGEST'><b>SUGGEST</b></Radio>
              <Radio style={radioStyle} value='DELETED'><b>DELETED</b></Radio>
            </Radio.Group>)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              OK
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateStatus = Form.create({
  name: 'UpdateStatus'
})(UpdateStatus)
export default (WrappedUpdateStatus)
